import React, { useContext, useState } from 'react';
import { PageContent } from './components';
import { AuthPath, AuthPageProps, PasswordProp, SetPasswordProp } from './models';
import * as s from './styles';
import { UserContext } from './UserProvider';
import { getLocalDevices, getPath, getExistingUserEnabledRedirect, useAuthForm } from './utils';
import { PhoneField } from '../../components/forms';
import authClient from '../../api/authClient';
import { normalizePhone, getCookie } from '../../utils';
import RedirectWhenEnabled, { EnabledRedirect } from './components/RedirectWhenEnabled';
import { PRIVACY_POLICY_URL, TERMS_OF_USE_URL, LinkId } from 'packages/smart-home-support/constants';
import { useTitle } from 'packages/smart-home-support/hooks';
import { ExtraLoginData } from 'packages/smart-home-support/api/models';

export type LoginPageProps = AuthPageProps & PasswordProp & SetPasswordProp;
const hasDevicesToSave = () => {
  const localDevices = getLocalDevices();
  return localDevices && Object.keys(localDevices).length;
};

const getExtraData = (): ExtraLoginData => {
  let extraData: ExtraLoginData = {};
  try {
    extraData = {
      cid: getCookie('c_id'),
      supportSessionId: getCookie('ss_id'),
    };
  } catch (err) {}
  return extraData;
};

const LoginPage: React.FC<LoginPageProps> = (props) => {
  useTitle('Login');
  const { user } = useContext(UserContext);

  const [needsConfirmation, setNeedsConfirmation] = useState(false);
  const [{ error, isLoading }, formController] = useAuthForm(async () => {
    const extraData = getExtraData();
    await authClient.loginPasswordless(normalizePhone(props.mdn), extraData);
    setNeedsConfirmation(true);
  });

  const redirects: EnabledRedirect[] = [
    getExistingUserEnabledRedirect(user),
    {
      enabled: needsConfirmation,
      to: getPath(AuthPath.Confirm),
    },
  ];

  return (
    <RedirectWhenEnabled redirects={redirects}>
      <PageContent
        isLoading={isLoading}
        heading={`Log in using your mobile number ${hasDevicesToSave() ? 'to save your devices' : ''}`}
      >
        <s.SignupForm onSubmit={formController.submit}>
          <PhoneField
            name="phone"
            label="Mobile device number"
            value={props.mdn}
            onChange={(e) => props.setMdn(e.target.value)}
            formController={formController}
          />
          {error && <s.Error>{error.message}</s.Error>}
          <s.SubmitButton type="submit">Verify number</s.SubmitButton>
          <s.FormHelp>
            By selecting verify number, you agree to the{' '}
            <s.FormHelpLink id={LinkId.AuthTermsOfUse} to={TERMS_OF_USE_URL} target="_blank">
              Terms of Use
            </s.FormHelpLink>{' '}
            and{' '}
            <s.FormHelpLink id={LinkId.AuthPrivacyPolicy} to={PRIVACY_POLICY_URL} target="_blank">
              Privacy Policy
            </s.FormHelpLink>
            .
          </s.FormHelp>
          <s.FinePrint>Data and message rates may apply.</s.FinePrint>
        </s.SignupForm>
      </PageContent>
    </RedirectWhenEnabled>
  );
};

export default LoginPage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/auth/LoginPage.tsx